<template>
  <proofreading-preview-plan slot="main" :novel-id="novelId" />
</template>

<script lang="ts">
import Vue from "vue";
import ProofreadingPreviewPlan from "@/components/organisms/proofreading/ProofreadingPreviewPlan.vue";

export default Vue.extend({
  metaInfo: {
    meta: [{ name: "robots", content: "none" }],
  },
  components: { ProofreadingPreviewPlan },
  props: {
    novelId: String,
  },
});
</script>
